var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _path0, _g3, _path1, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingAndDevelops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13506_34407)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 40,
    height: 40,
    rx: 5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 5.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "#06513D",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5631 23.1542H31.6354C31.8254 23.1583 31.9992 22.9845 31.9911 22.7905C31.9749 21.6102 31.8335 19.5125 31.0696 18.7082C29.764 17.3218 27.735 17.3057 27.6461 17.3057H25.5484C25.4595 17.3057 23.4305 17.3218 22.1209 18.7082C21.361 19.5125 21.2196 21.6143 21.2034 22.7905C21.1953 22.9845 21.3691 23.1583 21.5631 23.1542ZM22.6423 19.1973C23.7336 18.0413 25.5282 18.0211 25.5484 18.0211H27.6461C27.6663 18.0211 29.4569 18.0413 30.5522 19.2013C30.9443 19.6136 31.211 20.8382 31.2676 22.4388H21.9269C21.9835 20.8382 22.2502 19.6136 22.6423 19.1973Z",
    fill: "#06513D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0391 22.0797H35.9048V24.4361L35.25 23.7853C34.9186 23.4539 34.4134 23.9551 34.7448 24.2906L36.0059 25.5557C36.0746 25.6203 36.1675 25.6607 36.2605 25.6607C36.3575 25.6607 36.4464 25.6203 36.5151 25.5557L37.7802 24.2906C38.1076 23.9591 37.6064 23.4539 37.275 23.7853L36.6202 24.4361V21.724C36.6202 21.5259 36.4586 21.3643 36.2605 21.3643H33.0391C32.5703 21.3723 32.5703 22.0716 33.0391 22.0797Z",
    fill: "#06513D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9014 36.0391C35.7033 36.0391 35.5416 36.1967 35.5416 36.3947V38.1853H32.8255L33.4803 37.5305C33.8117 37.1991 33.3065 36.6938 32.9751 37.0253L31.71 38.2904C31.6089 38.3874 31.5766 38.5491 31.6332 38.6784C31.6493 38.7229 31.6776 38.7633 31.71 38.7956L32.9751 40.0607C33.3065 40.3921 33.8117 39.8869 33.4803 39.5555L32.8255 38.9007H35.9014C36.0994 38.9007 36.257 38.739 36.257 38.541V36.3947C36.257 36.1967 36.0994 36.0391 35.9014 36.0391Z",
    fill: "#06513D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5575 38.4084C21.5373 38.364 21.513 38.3236 21.4807 38.2912L20.2156 37.0261C19.8841 36.6947 19.3789 37.1999 19.7103 37.5313L20.3651 38.1861H17.649V36.3956C17.6409 35.9267 16.9417 35.9267 16.9336 36.3956V38.5459C16.9336 38.7399 17.0912 38.9015 17.2893 38.9015H20.3651L19.7103 39.5563C19.3789 39.8877 19.8841 40.393 20.2156 40.0615L21.4807 38.7964C21.5817 38.6994 21.6141 38.5378 21.5575 38.4084Z",
    fill: "#06513D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2209 29.8156C31.2007 29.7752 31.1764 29.7347 31.1401 29.7024L29.879 28.4373C29.5435 28.1059 29.0423 28.6111 29.3697 28.9425L30.0245 29.5973H23.1655L23.8203 28.9425C24.1477 28.6111 23.6465 28.1059 23.311 28.4373L22.0459 29.7024C21.9449 29.7994 21.9125 29.9611 21.9691 30.0904C21.9893 30.1349 22.0136 30.1753 22.0459 30.2076L23.311 31.4727C23.6424 31.8001 24.1477 31.2989 23.8203 30.9675L23.1655 30.3127H30.0245L29.3697 30.9675C29.0423 31.2989 29.5435 31.8001 29.879 31.4727L31.1401 30.2076C31.2411 30.1066 31.2735 29.949 31.2209 29.8156Z",
    fill: "#06513D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.678 25.5557C16.8114 25.6931 17.0498 25.6931 17.1832 25.5557L18.4483 24.2906C18.7798 23.9591 18.2745 23.4539 17.9431 23.7853L17.2883 24.4401V22.0797H20.154C20.6228 22.0756 20.6228 21.3723 20.154 21.3643H16.9326C16.7346 21.3643 16.5729 21.5259 16.5729 21.724V24.4401L15.9181 23.7853C15.5867 23.4539 15.0815 23.9591 15.4129 24.2906L16.678 25.5557Z",
    fill: "#06513D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13506_34407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 25,
    width: 11,
    height: 12
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9648 25.749H40.1277V36.0962H30.9648V25.749Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13506_34407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0943 31.7556L39.4718 31.3959C39.5324 31.0321 39.5324 30.6562 39.4718 30.2843L40.0943 29.9246C40.2681 29.8276 40.3246 29.6094 40.2276 29.4356L39.3708 27.9562C39.3223 27.8754 39.2455 27.8148 39.1566 27.7905C38.9504 27.7056 38.5503 28.0411 38.2593 28.1866C38.1138 28.0654 37.9602 27.9603 37.8025 27.8673C37.6449 27.7744 37.4751 27.6976 37.2973 27.6288V26.9094C37.2973 26.7113 37.1356 26.5537 36.9376 26.5537H35.2279C35.0298 26.5537 34.8722 26.7113 34.8722 26.9094V27.6288C34.5246 27.7622 34.1972 27.9522 33.9102 28.1866L33.2878 27.8269C33.114 27.7258 32.8957 27.7865 32.7987 27.9562L31.9418 29.4356C31.8448 29.6094 31.9014 29.8276 32.0752 29.9246L32.6977 30.2843C32.637 30.6522 32.637 31.028 32.6977 31.3959L32.0712 31.7556C31.9014 31.8566 31.8448 32.0749 31.9418 32.2446L32.7947 33.724C32.8957 33.8978 33.114 33.9543 33.2837 33.8573L33.9102 33.4976C34.2053 33.7401 34.5125 33.918 34.8722 34.0514V34.7708C34.8722 34.9689 35.0298 35.1305 35.2279 35.1305H36.9376C37.1356 35.1305 37.2973 34.9689 37.2973 34.7708V34.0514C37.6449 33.922 37.9723 33.732 38.2593 33.4976L38.8817 33.8573C39.0515 33.9543 39.2738 33.8978 39.3708 33.728L40.2276 32.2446C40.3246 32.0749 40.2681 31.8566 40.0943 31.7556ZM38.72 30.1914C38.8251 30.6198 38.8292 31.0685 38.7241 31.4929C38.6837 31.6464 38.7524 31.8081 38.8898 31.889L39.4274 32.2002L38.9302 33.0571L38.3926 32.7499C38.2552 32.669 38.0814 32.6892 37.9682 32.8024C37.653 33.1056 37.2609 33.3279 36.8406 33.4532C36.687 33.4976 36.5819 33.635 36.5819 33.7967V34.4151H35.5876V33.7927C35.5714 33.3642 34.9813 33.4087 34.7226 33.1945C34.4114 33.0813 34.1568 32.5478 33.7768 32.7499L33.2393 33.0571L32.7421 32.2002L33.2797 31.889C33.4171 31.8081 33.4858 31.6464 33.4454 31.4929C33.3403 31.0644 33.3403 30.6158 33.4454 30.1914C33.4858 30.0378 33.4171 29.8761 33.2757 29.7953L32.7421 29.4841L33.2393 28.6231L33.7728 28.9344C33.9143 29.0152 34.0881 28.995 34.2012 28.8818C34.5165 28.5787 34.9045 28.3523 35.3289 28.2311C35.4825 28.1866 35.5876 28.0492 35.5876 27.8875V27.2691H36.5819V27.8875C36.5981 28.32 37.1882 28.2715 37.4428 28.4857C37.7581 28.6029 38.0127 29.1365 38.3926 28.9344L38.9302 28.6231L39.4274 29.4841L38.8898 29.7953C38.7524 29.8761 38.6837 30.0378 38.72 30.1914Z",
    fill: "#06513D"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.593 34.6055C24.4225 34.6055 22.6562 36.3718 22.6562 38.5422C22.8745 43.7684 30.3156 43.7643 30.5298 38.5422C30.5298 36.3718 28.7635 34.6055 26.593 34.6055ZM26.593 41.7636C24.8186 41.7636 23.3717 40.3207 23.3717 38.5422C23.5495 34.27 29.6406 34.274 29.8144 38.5422C29.8144 40.3207 28.3714 41.7636 26.593 41.7636Z",
    fill: "#06513D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8631 37.2771L26.0443 39.096L25.1955 38.2472C24.864 37.9198 24.3588 38.421 24.6902 38.7524L25.7896 39.8559C25.8624 39.9246 25.9513 39.9609 26.0443 39.9609C26.1372 39.9609 26.2261 39.9246 26.2989 39.8559L28.3724 37.7824C28.6998 37.4509 28.1986 36.9457 27.8631 37.2771Z",
    fill: "#06513D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13506_34407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 25,
    width: 9,
    height: 11
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25.749H21.6617V35.0615H13V25.749Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13506_34407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4387 34.6052V33.5341H20.5138C20.7119 33.5341 20.8735 33.3724 20.8735 33.1744V26.7317C20.8735 26.5377 20.7119 26.376 20.5138 26.376H14.7865C14.5884 26.376 14.4308 26.5377 14.4308 26.7317V27.8068H13.3557C13.1576 27.8068 13 27.9685 13 28.1665V34.6052C13 34.8032 13.1576 34.9649 13.3557 34.9649H19.083C19.281 34.9649 19.4387 34.8032 19.4387 34.6052ZM15.1462 27.0914H20.1581V32.8187H15.1462V27.0914ZM13.7154 34.2495V28.5222H14.4308V33.1744C14.4308 33.3724 14.5884 33.5341 14.7865 33.5341H18.7233V34.2495H13.7154Z",
    fill: "#06513D"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.218 28.8824H19.0796C19.5484 28.8743 19.5484 28.1751 19.0796 28.167H16.218C15.7451 28.1751 15.7451 28.8743 16.218 28.8824Z",
    fill: "#06513D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.218 30.3131H19.0796C19.5484 30.305 19.5484 29.6057 19.0796 29.5977H16.218C15.7451 29.6057 15.7451 30.305 16.218 30.3131Z",
    fill: "#06513D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.218 31.7437H18.0045C18.4774 31.7356 18.4774 31.0364 18.0045 31.0283H16.218C15.7451 31.0364 15.7451 31.7356 16.218 31.7437Z",
    fill: "#06513D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5921 16.7111C28.1725 16.7111 29.4578 15.4258 29.4578 13.8495C29.3001 10.0502 23.8881 10.0502 23.7305 13.8495C23.7305 15.4258 25.0158 16.7111 26.5921 16.7111ZM26.5921 11.6992C27.7764 11.6992 28.7424 12.6652 28.7424 13.8495C28.6413 16.6909 24.5469 16.6909 24.4459 13.8495C24.4459 12.6652 25.4078 11.6992 26.5921 11.6992Z",
    fill: "#06513D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0932 29.2412C33.9793 29.3099 33.9793 32.3736 36.0932 32.4383C38.2031 32.3736 38.2031 29.3099 36.0932 29.2412ZM36.0932 31.7229C34.9292 31.6946 34.9292 29.989 36.0932 29.9566C37.2573 29.989 37.2573 31.6946 36.0932 31.7229Z",
    fill: "#06513D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13506_34407",
    x: 0.8,
    y: 0.8,
    width: 52.4,
    height: 52.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.529412 0 0 0 0 0.639216 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13506_34407"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13506_34407",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingAndDevelops);
export default __webpack_public_path__ + "static/media/TrainingAndDevelops.a6b0c5a7d748150d49194af1822dad2c.svg";
export { ForwardRef as ReactComponent };